export default value => value == null || value === false || value === true
